import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, catchError, throwError } from "rxjs";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

export interface fetchDataOptions {
	populate?: string;
	filters?: any;
	pagination?: {
		page: number;
		pageSize: number;
	};
	sort?: {
		field: string;
		order: string;
	};
	jwt?: string;
}

@Injectable({ providedIn: "root" })
export class RestApiService {
	private apiURL = environment.apiURL;
	collectionSubject = new BehaviorSubject<any>(null);

	constructor(private httpClient: HttpClient) {}

	get(endPoint: string, options?: fetchDataOptions): Observable<any> {
		let populate = options?.populate ? `&${options?.populate}` : ``;
		let filters = options?.filters ? `&${options?.filters}` : ``;
		let pagination = options?.pagination != undefined ? `&pagination[page]=${options.pagination.page}&pagination[pageSize]=${options.pagination.pageSize}` : ``;
		let sort = options?.sort != undefined ? `&sort=${options.sort.field}:${options.sort.order}` : `&sort=id:desc`;
		return this.httpClient.get<any>(`${this.apiURL}/${endPoint}?q${populate}${filters}${pagination}${sort}`);
	}

	post(endPoint: string, data: any): Observable<any> {
		data = { data: data };
		let headers = null;
		return this.httpClient.post(`${this.apiURL}/${endPoint}`, data, { headers }).pipe(catchError(this.handleError));
	}

	put(endPoint: string, id: number, data: any): Observable<any> {
		return this.httpClient.put(`${this.apiURL}/${endPoint}/${id}`, { data: data }).pipe(catchError(this.handleError));
	}

	delete(endPoint: string, id: number): Observable<any> {
		return this.httpClient.delete(`${this.apiURL}/${endPoint}/${id}`).pipe(catchError(this.handleError));
	}
	getCustom(endPoint: string, params: any = {}, options: any = {}): Observable<any> {
		let headers = {};
		console.log(`${this.apiURL}/${endPoint}`);
		return this.httpClient.get<any>(`${this.apiURL}/${endPoint}`, { headers: headers, ...options });
	}
	postCustom(endPoint: string, data: any, options: any = {}): Observable<any> {
		let headers = null;
		return this.httpClient.post(`${this.apiURL}/${endPoint}`, data, { headers, ...options }).pipe(catchError(this.handleError));
	}
	putCustom(endPoint: string, data: any): Observable<any> {
		return this.httpClient.put(`${this.apiURL}/${endPoint}`, data).pipe(catchError(this.handleError));
	}
	patch(endPoint: string, id: number, data: any): Observable<any> {
		return this.httpClient.patch(`${this.apiURL}/${endPoint}/${id}`, { data: data }).pipe(catchError(this.handleError));
	}

	// POST with FormData (for file uploads with Strapi)
	postWithFiles(endPoint: string, data: any, files: { [key: string]: File }): Observable<any> {
		const formData = new FormData();
		formData.append("data", JSON.stringify(data));
		for (const fieldName in files) {
			if (files[fieldName]) {
				formData.append(`files.${fieldName}`, files[fieldName]);
			}
		}
		return this.httpClient.post(`${this.apiURL}/${endPoint}`, formData).pipe(catchError(this.handleError));
	}

	// Upload file and link to existing entry (for Strapi)
	uploadFileToEntry(file: File, refId: number, ref: string, field: string): Observable<any> {
		const formData = new FormData();
		formData.append("files", file);
		formData.append("refId", refId.toString());
		formData.append("ref", ref);
		formData.append("field", field);
		return this.httpClient.post(`${this.apiURL}/upload`, formData).pipe(catchError(this.handleError));
	}

	//----------------------------------------------------------------
	handleError(errorResponse: HttpErrorResponse) {
		console.log("================== error====================");
		console.log(errorResponse);
		console.log("================== /error ==================");
		return throwError(errorResponse);
	}
}
